import {LobbyImage} from '@colonist/types'
import {TranslationObject} from '@colonist/i18n'
import {getLobbyImagePath} from '../../ui_utils/Utils'
import {UIUtilsEjsVariables} from '../../UIUtilsEjsVariables'
import {createDivIn, createImgIn} from '../../ui_utils/DomUtils.ts'
import {createTooltipIn} from '../../ui_utils/TooltipUtils.ts'

interface ReplayButtonOptions {
    small?: boolean
    tooltip?: TranslationObject
}
export class UIReplayButton {
    private action: () => void
    private asset: LobbyImage

    private readonly container: HTMLDivElement
    protected icon: HTMLImageElement
    tooltip?: HTMLSpanElement

    private readonly options: ReplayButtonOptions

    constructor(container: HTMLDivElement, asset: LobbyImage, action: () => void, options: ReplayButtonOptions = {}) {
        this.container = container
        this.asset = asset
        this.action = action
        this.options = options

        const isTooltipEnabled = !UIUtilsEjsVariables.isUserOnMobile
        this.buildView(isTooltipEnabled)
    }

    setAsset(asset: LobbyImage) {
        this.asset = asset
        this.icon.src = getLobbyImagePath(asset)
    }

    setAction(action: () => void) {
        this.action = action
        this.icon.onclick = this.action
    }

    setDisabled(disabled: boolean) {
        if(disabled) {
            this.icon.onclick = () => undefined
            this.icon.style.opacity = '0.5'
            return
        }

        this.icon.onclick = this.action
        this.icon.style.opacity = '1'
    }

    private buildView(isTooltipEnabled: boolean) {
        const buttonContainer = createDivIn(this.container, 'replay-button-container')

        if(this.options.small) buttonContainer.classList.add('replay-button-container-small')

        this.icon = createImgIn(buttonContainer, this.asset, 'replay-button')
        this.icon.onclick = this.action

        if(isTooltipEnabled && this.options.tooltip) createTooltipIn(this.icon, this.options.tooltip)
    }
}
